// extracted by mini-css-extract-plugin
export var measureBox = "_60-0";